<template>
    <section class="line-tips">
        <section class="txt">
            <indicators-data-component :data="lineTipsInfo"></indicators-data-component>
        </section>
        <section class="sanjiao"></section>
    </section>
</template>

<style lang="scss" scoped="scoped">
    .line-tips {
        width: 160px;
        height: 170px;
        border: 1px solid #2CA4F7;
        vertical-align: top;
        position: relative;
        display: inline-flex;
        align-items: center;
        border-right: 0;
        float: left;
        > .txt {
            position: absolute;
            left: -25px;
            padding: 10px 0;
            background-color: #FFF;
            > span {
                &:nth-child(1) {
                    font-size: 16px;
                    display: block;
                }
                &:nth-child(2) {
                    font-size: 34px;
                    display: block;
                    i {
                        font-size: 16px;
                    }
                }
                &:nth-child(3) {
                    font-size: 12px;
                    display: block;
                    color: #6E808B;
                }
                &:nth-child(4) {
                    font-size: 12px;
                    background-image: linear-gradient(-215deg, #FF4116 0%, #FF2851 100%);
                    box-shadow: 0 0 8px 0 rgba(255,52,51,0.22);
                    border-radius: 100px;
                    color: #FFF;
                    padding: 0 10px;
                }
            }
        }
        > .sanjiao {
            position: absolute;
            width: 0;
            height: 0;
            border-left: 10px solid #29A3FC;
            border-top: 5px solid transparent;
            border-right: 0;
            border-bottom: 5px solid transparent;
            right: 0;
            bottom: -5px;
        }
    }
</style>

<script>
    import IndicatorsDataComponent from '../../../components/indicators-data/IndicatorsData.vue'

    export default {
        components: {
	        IndicatorsDataComponent
        },
        data () {
            return {
            }
        },
        props: ["lineTipsInfo"],
        methods: {

        }
    }
</script>



// WEBPACK FOOTER //
// LineTips.vue?b99f902e